<template>
  <div>
    <input-field v-focus v-model="account.name" :label="accountNamePlaceholder" />

    <div class="flex flex-row justify-between gap-2">
      <input-field v-model="account.user.firstName" label="First name" />
      <input-field v-model="account.user.lastName" label="Last name" />
    </div>

    <input-field :value="account.user.email" @input="onEmailChange" label="Email address" type="email" :error="emailTaken ? 'Email is already taken' : ''" />
  </div>
</template>

<script>
import debounce from 'debounce';
import axios from 'axios';

export default {
  props: {
    emailTaken: {
      type: Boolean,
      required: true
    },
    account: {
      type: Object,
      required: true
    }
  },

  computed: {
    accountNamePlaceholder() {
      return this.appName === 'LawSync' ? 'Firm name' : 'Company';
    },
  },

  methods: {
    onEmailChange: debounce(async function (email) {
      const { data: { exists } } = await axios.post('/api/validate-email', {
        email
      }, {
        headers: { 'X-CSRF-TOKEN': document.querySelector('input[name=_token]').value }
      });

      this.$emit('update:emailTaken', exists);

      this.account.user.email = email;
    }, 500)
  }
};
</script>
